import React, { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Outlet } from 'react-router-dom';
import store from '../store/store';
import { isOktaAuthenticated, oktaLogin } from 'utils/okta_auth';

const PrivateRoutes = () => {
  const oktaContext = useOktaAuth();
  const authState = oktaContext?.authState;
  const oktaAuth = oktaContext?.oktaAuth;
  const isMFE = store.getState().app.isMFE;

  async function authenticate() {
    if (!authState) {
      return;
    }

    if (!isOktaAuthenticated(authState)) {
      oktaLogin(oktaAuth);
    }
  }

  useEffect(() => {
    if (!isMFE) {
      if (!authState) {
        return;
      }

      if (!authState?.isAuthenticated) {
        authenticate();
      }
    }
  }, [oktaAuth, !!authState, authState?.isAuthenticated, isMFE]);

  if (!isMFE && (!authState || !authState?.isAuthenticated)) {
    return null;
  }

  return <Outlet />;
};

export default PrivateRoutes;
